<app-page-section>
  <div class="mb-4">
    <p class="text-uppercase text-primary fw-semibold small mb-2">Moderation</p>
    <h1 class="display-5 fw-bold">Offer review queue</h1>
    <p class="lead text-muted">Review public PhD offer submissions before approved offers enter matching ingestion.</p>
  </div>

  @if (error) { <div class="alert alert-danger">{{ error }}</div> }

  <div class="moderation-card">
    <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
      <div>
        <h2 class="h5 mb-1">Submitted offers</h2>
        <p class="text-muted small mb-0">Admins are moderators too; MODO users can access this page without full admin operations.</p>
      </div>
      <div class="d-flex gap-2">
        <select class="form-select form-select-sm" [ngModel]="submissionStatus" (ngModelChange)="changeSubmissionStatus($event)" aria-label="Submission status filter">
          <option value="PENDING">Pending</option>
          <option value="APPROVED">Approved</option>
          <option value="REJECTED">Rejected</option>
        </select>
        <button class="btn btn-outline-primary btn-sm" type="button" (click)="loadOfferSubmissions()" [disabled]="isLoading">Refresh</button>
      </div>
    </div>

    <div class="row g-3">
      <div class="col-lg-4">
        @if (!offerSubmissions.length) { <p class="text-muted mb-0">No submissions in this view.</p> }
        @for (submission of offerSubmissions; track submission.submissionId) {
          <button class="submission-list-item text-start w-100 mb-2" type="button" (click)="selectSubmission(submission)" [class.active]="selectedSubmission?.submissionId === submission.submissionId">
            <strong>{{ submission.title }}</strong><br>
            <span class="small text-muted">{{ submission.organization }} · {{ submission.country }}</span>
          </button>
        }
      </div>

      <div class="col-lg-8">
        @if (selectedSubmission) {
          <article class="border rounded-3 p-3">
            <div class="d-flex flex-wrap justify-content-between gap-2 mb-2">
              <h3 class="h5 mb-0">{{ selectedSubmission.title }}</h3>
              <span class="badge text-bg-secondary">{{ selectedSubmission.status }}</span>
            </div>
            <p class="mb-1"><strong>Contributor:</strong> {{ selectedSubmission.contributorEmail }}</p>
            <p class="mb-1"><strong>Organization:</strong> {{ selectedSubmission.organization }}</p>
            <p class="mb-1"><strong>Location:</strong> {{ selectedSubmission.location }}, {{ selectedSubmission.country }}</p>
            <p class="mb-1"><strong>Deadline:</strong> {{ selectedSubmission.deadline }} · <strong>Published:</strong> {{ selectedSubmission.publishedAt }}</p>
            <p class="mb-1"><strong>Source:</strong>
              @if (safeExternalUrl(selectedSubmission.sourceUrl)) {
                <a [href]="safeExternalUrl(selectedSubmission.sourceUrl)" target="_blank" rel="noopener noreferrer">{{ selectedSubmission.sourceUrl }}</a>
              } @else {
                <span>{{ selectedSubmission.sourceUrl }}</span>
              }
            </p>
            <p class="mb-1"><strong>Apply:</strong> {{ selectedSubmission.applyLink }}</p>
            <p class="mb-1"><strong>Areas:</strong> {{ selectedSubmission.researchAreas.join(', ') }}</p>
            <p class="mt-3 white-space-pre-line">{{ selectedSubmission.description }}</p>
            <p><strong>Requirements:</strong> {{ selectedSubmission.requirements.join(', ') }}</p>
            <p><strong>Benefits:</strong> {{ selectedSubmission.benefits.join(', ') }}</p>
            <p><strong>Contact:</strong> {{ selectedSubmission.contact }}</p>
            @if (selectedSubmission.hasPdf) { <button class="btn btn-outline-secondary btn-sm mb-3" type="button" (click)="openSubmissionPdf(selectedSubmission)" [disabled]="isLoading"><i class="bi bi-file-earmark-pdf me-2"></i>Open PDF</button> }
            @if (selectedSubmission.status === 'PENDING') {
              <label class="form-label" for="moderationNotes">Moderation notes</label>
              <textarea id="moderationNotes" class="form-control mb-3" rows="3" [(ngModel)]="moderationNotes" placeholder="Optional internal/rejection note"></textarea>
              <div class="d-flex flex-wrap gap-2">
                <button class="btn btn-success" type="button" (click)="approveSubmission()" [disabled]="isLoading">Approve and ingest</button>
                <button class="btn btn-outline-danger" type="button" (click)="rejectSubmission()" [disabled]="isLoading">Reject</button>
              </div>
            } @else {
              <p class="text-muted small mb-0">Reviewed by {{ selectedSubmission.reviewedBy || 'moderator' }} on {{ selectedSubmission.reviewedAt || selectedSubmission.updatedAt || 'unknown date' }}.</p>
            }
          </article>
        } @else {
          <div class="border rounded-3 p-4 text-muted">Select a submission to review its full details.</div>
        }
      </div>
    </div>
  </div>
</app-page-section>
